import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://vonhoxncozfnfkpxdcsm.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZvbmhveG5jb3pmbmZrcHhkY3NtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg4NzA2OTIsImV4cCI6MjA3NDQ0NjY5Mn0.gud_jRXuS6iH7TdWlqj-FNYLlEhwYwJiDvyELWf3cYM'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
